export enum DocumentUrlKeyword {
    JobProgram = 0,
    ControlPoint = 1,
    PlugBase = 2,
    FluidTest = 3,
    GeneralLinear = 4,
    ExpandableLinear = 5,
  }